export enum TableUtilityCellType {
	THUMBNAIL = '__thumbnail',
	ACTIONS = '__actions',
	DRAG_HANDLE = '__dragHandle',
	SELECTION = '__selection',
}
